export default __webpack_public_path__ + "static/media/icon1.11adcf4c.svg";